import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { OrganisationInstallSummaryType } from "@intelligentlilli/api-layer";

interface CacheEntry {
  data: OrganisationInstallSummaryType;
  fetchedAt: number;
}

interface InstallPerformanceState {
  cache: Record<string, CacheEntry>;
}

const initialState: InstallPerformanceState = {
  cache: {},
};

export const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

const installPerformanceSlice = createSlice({
  name: "installPerformance",
  initialState,
  reducers: {
    setCacheEntry(
      state,
      action: PayloadAction<{ key: string; data: OrganisationInstallSummaryType }>
    ) {
      state.cache[action.payload.key] = {
        data: action.payload.data,
        fetchedAt: Date.now(),
      };
    },
    clearCache(state) {
      state.cache = {};
    },
  },
});

export const { setCacheEntry, clearCache } = installPerformanceSlice.actions;
export default installPerformanceSlice.reducer;
